import request from '@/utils/request'

//查询菜单
export function getRoutes() {
  return request({
    url: '/base/personalCenter/router',
    method: 'get'
  })
}

//编辑角色-菜单关系
export function addOrUpdJscd(data) {
  return request({
    url: '/sys/role/edit',
    method: 'post',
    data
  })
}

//编辑角色
export function delteJs(data) {
  return request({
    url: '/sys/role/dels',
    method: 'post',
    data
  })
}

export function addRole(data) {
  return request({
    url: '/vue-element-admin/role',
    method: 'post',
    data
  })
}

export function updateRole(id, data) {
  return request({
    url: `/vue-element-admin/role/${id}`,
    method: 'put',
    data
  })
}

export function deleteRole(id) {
  return request({
    url: `/vue-element-admin/role/${id}`,
    method: 'delete'
  })
}
